import { Component } from '@angular/core';

/**
 * Generated class for the GiftIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lubbu-icon',
  templateUrl: 'lubbu-icon.html'
})
export class LubbuIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-icon/lubbu-icon.ts